import { MRT_Localization } from 'material-react-table';
import { MRT_Localization_CS } from 'material-react-table/locales/cs';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { useIntl } from 'react-intl';

export function useMaterialReactTableLocalization(): MRT_Localization {
  const { locale } = useIntl();

  return locale === 'cs' ? MRT_Localization_CS : MRT_Localization_EN;
}
